import React from 'react'
import { Card, CardBody } from "reactstrap"
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import Itemv2 from './Itemv2'

const List = ({
  list,
  viewProduct,
  deleteProduct,
  showSetQuantity,
  onChangeQuantity,
  loading,
}) => {

  return (
    <React.Fragment>
      <div style={{ display: 'block' }}>
        {!loading && isEmpty(list) && (
          <React.Fragment>
            <Card>
              <CardBody>
                No cuentas con productos en tu carrito.
                Recuerda que estamos para ayudarte en todo el proceso.
                <br /><br />
                <Link to={`/discovery`} className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2">
                  <i className="mdi mdi-plus mr-1"></i> Explorar productos
                </Link>
              </CardBody>
            </Card>
          </React.Fragment>
        )}
        {!loading && !isEmpty(list) && list.map((item, key) => (
          <div key={`grid_${key}`}>
            <Itemv2
              item={item}
              view={viewProduct}
              remove={deleteProduct}
              showSetQuantity={showSetQuantity}
              onChangeQuantity={onChangeQuantity}
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

export default List
